import React from 'react';
import { motion } from 'framer-motion';
import '../styles/Preloader.css';

const Preloader = () => {
  const containerVariants = {
    hidden: { opacity: 1 },
    exit: {
      opacity: 0,
      transition: {
        duration: 0.5,
        ease: 'easeInOut'
      }
    }
  };

  const circleVariants = {
    hidden: { scale: 0, opacity: 0 },
    visible: (i) => ({
      scale: [0, 1, 0],
      opacity: [0, 1, 0],
      transition: {
        duration: 2,
        repeat: Infinity,
        delay: i * 0.3,
        ease: 'easeInOut'
      }
    })
  };

  const textVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 1,
        ease: 'easeOut'
      }
    }
  };

  const progressVariants = {
    hidden: { scaleX: 0 },
    visible: {
      scaleX: 1,
      transition: {
        duration: 2.5,
        ease: 'easeInOut'
      }
    }
  };

  return (
    <motion.div
      className="preloader-container"
      variants={containerVariants}
      initial="hidden"
      exit="exit"
    >
      <div className="preloader-content">
        {/* Animated circles */}
        <div className="preloader-circles">
          {[0, 1, 2].map((i) => (
            <motion.div
              key={i}
              className="preloader-circle"
              custom={i}
              variants={circleVariants}
              initial="hidden"
              animate="visible"
            />
          ))}
        </div>

        {/* Brand text */}
        <motion.div
          className="preloader-text"
          variants={textVariants}
          initial="hidden"
          animate="visible"
        >
          <h2>Active Care Residential</h2>
          <p className="preloader-subtext">Supporting Lives and empowering others where care meets quality of Life</p>
          <p className="preloader-subtext">Registration: 14464980</p>
        </motion.div>

        {/* Progress bar */}
        <motion.div
          className="preloader-progress"
          variants={progressVariants}
          initial="hidden"
          animate="visible"
        />

        {/* Loading dots */}
        <div className="preloader-dots">
          {[0, 1, 2].map((i) => (
            <motion.span
              key={i}
              className="preloader-dot"
              animate={{
                y: [0, -10, 0],
                opacity: [0.5, 1, 0.5]
              }}
              transition={{
                duration: 1.4,
                repeat: Infinity,
                delay: i * 0.15
              }}
            />
          ))}
        </div>
      </div>

      {/* Background animation */}
      <div className="preloader-background">
        {[...Array(20)].map((_, i) => (
          <motion.div
            key={i}
            className="preloader-bg-element"
            animate={{
              scale: [1, 1.5, 1],
              opacity: [0.1, 0.3, 0.1],
              rotate: [0, 360]
            }}
            transition={{
              duration: 5 + i * 0.2,
              repeat: Infinity,
              ease: 'easeInOut'
            }}
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`
            }}
          />
        ))}
      </div>
    </motion.div>
  );
};

export default Preloader;
